import {
  EarningsInsight,
  EarningsInsightFilterResponse,
  EarningsInsightPreviewResponse,
  EarningsInsightPreviewV4Response,
  EarningsInsightsFilterRequest,
  earningsInsights,
} from '@api';
import { deduplicateEarningsInsights } from '@terminal/react-query-hooks/insights/useEarningsInsightsFilter.utils';
import { apiFetch, wretchRequest } from '@terminal/utils/api-fetch/apiFetch';
import { getKgEarningsInsightsForChart } from './kg-insights-service';

export const QUERY_KEY_EARNINGS_INSIGHT_PREVIEW =
  'QUERY_KEY_EARNINGS_INSIGHT_PREVIEW';
export const QUERY_KEY_EARNINGS_INSIGHT_PREVIEW_V4 =
  'QUERY_KEY_EARNINGS_INSIGHT_PREVIEW_V4';

const getEarningsInsightsFilter = async (
  payload: EarningsInsightsFilterRequest
) => {
  const { path, schema } = earningsInsights.postEarningsInsightFilter;

  return await apiFetch<EarningsInsightFilterResponse>(path, {
    method: 'post',
    body: payload,
    schema,
  });
};

export const getEarningsInsightPreview = (
  earningsInsightId: string,
  signal?: AbortSignal
) => {
  const { path, schema } = earningsInsights.getEarningsInsightPreview;
  return wretchRequest<EarningsInsightPreviewResponse>(
    path(earningsInsightId),
    {
      schema,
      signal,
    }
  );
};

export const getEarningsInsightPreviewV4 = (
  earningsInsightId: string,
  signal?: AbortSignal
) => {
  const { path, schema } = earningsInsights.getEarningsInsightPreviewV4;
  return wretchRequest<EarningsInsightPreviewV4Response>(
    path(earningsInsightId),
    {
      schema,
      signal,
    }
  );
};

export const getEarningsInsightsForChart = async (
  payload: EarningsInsightsFilterRequest
): Promise<EarningsInsight[]> => {
  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined)
  ) as EarningsInsightsFilterRequest;

  const [earningsInsightsResponse, kgEarningsInsightsResponse] =
    await Promise.allSettled([
      getEarningsInsightsFilter(cleanedPayload),
      getKgEarningsInsightsForChart(cleanedPayload),
    ]);

  const kgEarningsInsightsData =
    kgEarningsInsightsResponse.status === 'fulfilled'
      ? (kgEarningsInsightsResponse.value.data ?? [])
      : [];
  const earningsInsightsData =
    earningsInsightsResponse.status === 'fulfilled'
      ? (earningsInsightsResponse.value.data ?? [])
      : [];

  return deduplicateEarningsInsights([
    ...kgEarningsInsightsData,
    ...earningsInsightsData,
  ]);
};
